import { render } from "./BotRive.vue?vue&type=template&id=2eb26878&scoped=true"
import script from "./BotRive.vue?vue&type=script&lang=js"
export * from "./BotRive.vue?vue&type=script&lang=js"

import "./BotRive.vue?vue&type=style&index=0&id=2eb26878&lang=scss&scoped=true"

import exportComponent from "F:\\homework\\tokenza\\tokenza\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eb26878"]])

export default __exports__